var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C10.5523 2 11 2.44772 11 3V4H21V3C21 2.44772 21.4477 2 22 2C22.5523 2 23 2.44772 23 3V4H26C27.1046 4 28 4.89543 28 6V26C28 27.1046 27.1046 28 26 28H6C4.89543 28 4 27.1046 4 26V6C4 4.89543 4.89543 4 6 4H9V3C9 2.44772 9.44772 2 10 2ZM9 6H6V10H26V6H23V7C23 7.55228 22.5523 8 22 8C21.4477 8 21 7.55228 21 7V6H11V7C11 7.55228 10.5523 8 10 8C9.44772 8 9 7.55228 9 7V6ZM26 12H6V26H26V12Z",
    fill: "#969597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGrey);
export default __webpack_public_path__ + "static/media/calendar_grey.6649439dd23cdcc02660adc64c95ac71.svg";
export { ForwardRef as ReactComponent };